"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var distillUtilityClasses_1 = __importDefault(require("../utility/distillUtilityClasses"));
var Orientation;
(function (Orientation) {
    Orientation["Horizontal"] = "+x";
    Orientation["Vertical"] = "+y";
})(Orientation || (Orientation = {}));
;
exports.AppLayout = function (props) {
    var classes = __spreadArrays([
        "l-app",
        props.gap ? "+gap-" + props.gap : "",
        props.orientation
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' ') }, props.children);
};
var Position;
(function (Position) {
    Position["Start"] = "+start";
    Position["Middle"] = "+middle";
    Position["End"] = "+end";
})(Position || (Position = {}));
var AppLayoutItem = function (props) {
    var classes = __spreadArrays([
        "l-app__item",
        props.position
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' '), style: props.style }, props.children);
};
var AppLayoutWrap = function (props) {
    var classes = __spreadArrays([
        "l-app__wrap",
        props.gap ? "+gap-" + props.gap : ""
    ], distillUtilityClasses_1.default(props));
    return react_1.default.createElement("div", { className: classes.join(' ') }, props.children);
};
AppLayoutItem.Position = Position;
exports.AppLayout.Wrap = AppLayoutWrap;
exports.AppLayout.Orientation = Orientation;
exports.AppLayout.Item = AppLayoutItem;
//# sourceMappingURL=AppLayout.js.map